/**
 * Organization Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const EasypassPaymentBehavior = {
    OrgPays: 'OrgPays',
    ParkerPays: 'ParkerPays'
} as const;
export type EasypassPaymentBehavior = typeof EasypassPaymentBehavior[keyof typeof EasypassPaymentBehavior];

